import React from 'react';

import Article from '../Article/index.jsx';
import ArticleList from '../ArticleList/index.jsx';
import ArticleFilterPane from '../ArticleFilterPane/index.jsx';
import LoadMore from '../LoadMore/index.jsx';
import Spinner from '../Spinner/index.jsx';


class ContentFeedList extends React.Component {
  render() {
    var content = [];

    if (this.props.articles.length) {
      for (var i = 0; i < this.props.articles.length; i++) {
        var article = this.props.articles[i];

        content.push(
          <ArticleList.Item key={article.id}>
            <Article article={article} />
          </ArticleList.Item>
        );
      }
    }
    else if (!this.props.fetching && this.props.articles.length === 0) {
      content.push(<p key={'nothing-to-show'}>Nothing to show.</p>);
    }


    return (
      <ArticleList>
        {content}
      </ArticleList>
    );
  }
}


export default ContentFeedList;

